import { ObjectStatuses } from '@zipari/shared-ds-util-status';

export interface CalendarConfig {
  currentYear: number;
  currentMonth: number;
  statusses: ObjectStatuses;
  dataMatchProp: string;
}
export interface DisplayDay {
  date: Date;
  dateString: string;
  dayOfTheMonth: number;
  isCurrentMonth: boolean;
  data?: any[];
}

export interface CalendarArgs {
  config: CalendarConfig;
  data: unknown;

  statusPillCliked?: () => void;
  mobileDayClicked?: (args: unknown[]) => void;
}
